import { secureApiGet } from '../secureHttp';

export interface PatientProcessItem {
  id: string;
  status: string;
  type?: unknown;
  psychologist?: unknown;
  preferences?: unknown[];
  next_session?: unknown;
  total_sessions?: number;
  can_schedule?: boolean;
  created_at?: string;
}

export interface PatientProcessesResponse {
  data: PatientProcessItem[];
}

export async function getPatientProcesses(): Promise<PatientProcessesResponse> {
  const resp = await secureApiGet<unknown>('/v1/patients');

  type StatusValue = string | { name?: string };
  interface PatientApiUser { created_at?: string }
  interface PatientApiItem {
    id?: unknown;
    status?: StatusValue;
    type?: unknown;
    psychologist?: unknown;
    preferences?: unknown[];
    next_session?: unknown;
    total_sessions?: number;
    can_schedule?: boolean;
    created_at?: string;
    user?: PatientApiUser;
  }

  function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
  }

  const normalize = (input: unknown): PatientProcessItem[] => {
    if (Array.isArray(input)) {
      return (input as PatientApiItem[]).map((it) => ({
        id: String((it && 'id' in it ? it.id : '') ?? ''),
        status: String((it && 'status' in it ? (typeof it.status === 'string' ? it.status : it.status?.name) : '-') ?? '-'),
        type: (it && 'type' in it ? it.type : undefined),
        psychologist: (it && 'psychologist' in it ? it.psychologist : undefined),
        preferences: (it && 'preferences' in it ? it.preferences : undefined),
        next_session: (it && 'next_session' in it ? it.next_session : undefined),
        total_sessions: (it && 'total_sessions' in it ? it.total_sessions : undefined),
        can_schedule: (it && 'can_schedule' in it ? it.can_schedule : undefined),
        created_at: (it && 'created_at' in it ? it.created_at : (it && 'user' in it ? it.user?.created_at : undefined))
      }));
    }
    if (isRecord(input)) {
      const obj = input as Record<string, unknown> & { results?: unknown; data?: unknown };
      if (Array.isArray(obj.results as unknown[])) return normalize(obj.results as unknown[]);
      if (Array.isArray(obj.data as unknown[])) return normalize(obj.data as unknown[]);
    }
    return [];
  };

  const data = normalize(resp);
  return { data };
}


